import {FC, useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {RegistroModAplicativo, RegistroRol1, useAuth} from '../../modules/auth'
import {getFuncionalidades} from '../../modules/auth/core/_requests'
import {Navbar} from '../../../_metronic/layout/components/header/Navbar'
import ModalUserModule from './Modal/ModalUserModule'
import {useIntl} from 'react-intl'

const UserModule: FC = () => {
  const intl = useIntl()
  // const [data, setData] = useState<RegistroModAplicativo[]>([])
  const [dataRoles, setDataRoles] = useState<RegistroRol1[]>([])
  const {currentUser, setCurrentUser, saveAuth, auth} = useAuth()
  const navigate = useNavigate()
  const [loadingButton, setLoadingButton] = useState<string | null>(null)

  const getFunc = async (
    IdRolesxAplicatxOV: number,
    idOrgSaas: number,
    DescripcionOrgSaas: string,
    idOrgV: string,
    descripcionOrgV: string,
    idOrgVExt: string,
    idAplicativoxOV: number,
    idRol: string,
    descripcionRol: string,
    idIndustria: number
  ) => {
    setLoadingButton(`${IdRolesxAplicatxOV}`)

    try {
      const {data} = await getFuncionalidades(IdRolesxAplicatxOV)
      if (data.message.msgId == '0') {
        const auxUser = currentUser

        if (auxUser) {
          auxUser.registro.funcionalidad = data.registro.accesosTree
          auxUser.registro.IdOrgSaas = idOrgSaas
          auxUser.registro.IdOrgV = idOrgV
          auxUser.registro.DescripcionOrgV = descripcionOrgV
          auxUser.registro.IdOrgVExt = idOrgVExt
          auxUser.registro.IdAplicativoxOV = idAplicativoxOV
          auxUser.registro.IdRol = idRol
          auxUser.registro.DescripcionRol = descripcionRol
          auxUser.registro.IdIndustria = idIndustria
        }

        const auxLocal = auth
        if (auxLocal) {
          auxLocal.IdOrgV = idOrgV
          auxLocal.DescripcionOrgV = descripcionOrgV

          auxLocal.IdRol = idRol
          auxLocal.IdAplicativoxOV = idAplicativoxOV
          auxLocal.funcionalidad = data.registro.accesosTree
          auxLocal.DescripcionRol = descripcionRol
          auxLocal.IdOrgSaas = idOrgSaas
          auxLocal.DescripcionOrgSaas = DescripcionOrgSaas
          auxLocal.IdIndustria = idIndustria
        }

        const auxLocal1 = auxLocal
        saveAuth(auxLocal1)

        const auxUser1 = auxUser
        setCurrentUser(auxUser1)
      }
      navigate('/dashboard')
    } catch (error) {
      console.error(error)
    }

    setLoadingButton(null)
  }

  useEffect(() => {
    if (currentUser?.roles) {
      const roles: RegistroRol1[] = currentUser.roles
      setDataRoles(roles)

      if (currentUser.roles.length === 1) {
        getFunc(
          roles[0].IdRolesxAplicatxOV,
          roles[0].IdOrgSaas,
          roles[0].DescripcionOrgSaas,
          roles[0].IdOrgV,
          roles[0].DescripcionOrgV,
          roles[0].IdOrgVExt,
          roles[0].IdAplicativoxOV,
          roles[0].IdRol,
          roles[0].Descripcion,
          roles[0].IdIndustria
        )
      }
    }
  }, [currentUser])

  return (
    <>
      <div className='d-flex justify-content-end mx-5 '>
        {/* <Navbar showPrompts={false} /> */}
        <ModalUserModule />
      </div>
      <div className='m-10 card mt-3' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {intl.formatMessage({id: 'WELCOME_ROL'})}{' '}
              {currentUser?.registro && currentUser.registro.Nombres
                ? currentUser.registro.Nombres
                : ' '}
            </h3>
          </div>
        </div>
        <div className='card-body p-4 mx-3' style={{maxHeight: '450px', overflowY: 'auto'}}>
          {dataRoles.length > 0 ? (
            <>
              {dataRoles.map((d) => (
                <div
                  key={d.IdRolesxAplicatxOV}
                  className='d-flex align-items-center  rounded  p-3 mb-3 border border-secondary'
                >
                  <div
                    className='flex-grow-1 me-3 cursor-pointer'
                    onClick={() =>
                      getFunc(
                        d.IdRolesxAplicatxOV,
                        d.IdOrgSaas,
                        d.DescripcionOrgSaas,
                        d.IdOrgV,
                        d.DescripcionOrgV,
                        d.IdOrgVExt,
                        d.IdAplicativoxOV,
                        d.IdRol,
                        d.Descripcion,
                        d.IdIndustria
                      )
                    }
                  >
                    <span className='fw-bold text-dark fs-5 '>
                      {d.Descripcion} - {d.DescripcionOrgSaas} - {d.DescripcionOrgV}
                    </span>
                  </div>
                  <button
                    className='btn btn-primary'
                    onClick={() =>
                      getFunc(
                        d.IdRolesxAplicatxOV,
                        d.IdOrgSaas,
                        d.DescripcionOrgSaas,
                        d.IdOrgV,
                        d.DescripcionOrgV,
                        d.IdOrgVExt,
                        d.IdAplicativoxOV,
                        d.IdRol,
                        d.Descripcion,
                        d.IdIndustria
                      )
                    }
                  >
                    {loadingButton === `${d.IdRolesxAplicatxOV}` ? (
                      <span className='indicator-progress d-flex align-items-center'>
                        Espere por favor...
                        <span className='spinner-border spinner-border-sm ms-2'></span>
                      </span>
                    ) : (
                      'Acceder'
                    )}
                  </button>
                </div>
              ))}
            </>
          ) : (
            <div className='text-center text-muted py-5'>
              <span className='fw-bold fs-5'>No hay Roles permitidos para este usuario.</span>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export {UserModule}
